import React, { Component } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import redirectURL from "../redirectURL";
import 'react-datetime/css/react-datetime.css';
import Datetime from 'react-datetime';
import moment from 'moment';

// Load the packed bubble module from Highcharts
require('highcharts/modules/exporting')(Highcharts);
require('highcharts/highcharts-more')(Highcharts);

var decipher = salt => {
  const textToChars = text => text.split('').map(c => c.charCodeAt(0));
  const applySaltToChar = code => textToChars(salt).reduce((a, b) => a ^ b, code);
  return encoded => encoded.match(/.{1,2}/g)
      .map(hex => parseInt(hex, 16))
      .map(applySaltToChar)
      .map(charCode => String.fromCharCode(charCode))
      .join('');
}
var decode = decipher("Z744cRBHYjQTsI6cOlNaUKbuEQF6MiEr");
var localStorageRole = (localStorage.getItem("role"))


class ShipmentDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      series: [],
      from_date: moment().format('DD-MM-YYYY'),
      end_date: moment().add(2, 'days').format('DD-MM-YYYY'),
    };
  }

  componentDidMount() {
    this.getdata(this.state.from_date, this.state.end_date);
  }

  getdata = (from_date, to_date) => {
    this.setState({ loadshow: 'show-m' });

    if (from_date === '' || from_date === undefined || to_date === '' || to_date === undefined) {
      from_date = this.state.from_date;
      to_date = this.state.end_date;
    }

    var params = {
      from_date: formatDate(from_date),
      to_date: formatDate(to_date),
    };

   


    // Fetch data for the bubble chart
    redirectURL.post('/getpiechartforshipment', params).then((resp) => {
      var records = resp.data;
      if (decode(localStorageRole).toLowerCase() === "user") {
        // Set filter parameters
        var location = localStorage.getItem("location");

        const consignerFilter = location;
        const consigneeFilter = location;
    
        // Filter records based on consigner_code and consignee_code
        records = records.filter(record => 
            record.consigner_code === consignerFilter ||
            record.consignee_code === consigneeFilter
        );
        const truckSealEntity = localStorage.getItem("entity");
        if (truckSealEntity  && truckSealEntity !== undefined && truckSealEntity !== null && truckSealEntity.trim() !== "") {
            
            // Additional filtering based on truck_seal_entity
            records = records.filter(record => record.truck_seal_entity === truckSealEntity);
        } 
    }
    
      var noBreach = records.days_equal_to_zero;
      var oneToTwoDaysBreach = records.days_more_than_one ;
      var threeToFiveDaysBreach = records.days_more_than_three;
      var sixToTenDaysBreach = records.days_more_than_six;
      var greaterTenDaysBreach = records.days_more_than_ten;

      // var noBreach = 2;
      // var oneToTwoDaysBreach = 6;
      // var threeToFiveDaysBreach = 7;
      // var sixToTenDaysBreach = 3;
      // var greaterTenDaysBreach = 20;

      // Transform the data into the format for the packed bubble chart
      var data = [
        { name: '0-1 days', value: noBreach },
        { name: '1-2 days', value: oneToTwoDaysBreach },
        { name: '3-5 days', value: threeToFiveDaysBreach },
        { name: '6-10 days', value: sixToTenDaysBreach },
        { name: '>10 days', value: greaterTenDaysBreach },
      ];

      this.setState({ 
        series: data
      }, () => {
        this.renderChart();
      });
    });
  }

  renderChart = () => {
    Highcharts.chart('container-c', {
      chart: {
        type: 'packedbubble',
        height: '85%',
      },
      title: {
        text: ''
      },
      subtitle: {
        text: ''
      },
      tooltip: {
        useHTML: true,
        pointFormat: '<b>{point.name}: {point.value}</b>'
      },
      plotOptions: {
        packedbubble: {
          minSize: '60%',
          maxSize: '180%',
          zMin: 0,
          zMax: 1000,
          layoutAlgorithm: {
            splitSeries: false,
            gravitationalConstant: 0.02
          },
          dataLabels: {
            enabled: true,
            format: '{point.name}',
            style: {
              opacity: 1,
              fillOpacity: 1,
              fontSize: "13px"
            }
          },
          marker: {
            fillOpacity: 1 // Ensures fill opacity for the bubbles
          }
        }
      },
      colors: ['#f35e82', '#7f84e9'],
      series: [{
        name: 'Transit Delay Days',
        // colorByPoint: true,
        data: this.state.series
      }],
      credits: false,
      exporting: {
        enabled: false // This disables the context menu (exporting options)
      }
    });
  }

  filterDatafordates = () => {
    const { from_date, end_date } = this.state;
    this.getdata(from_date, end_date);
  }

  handleDatesSelected = (e) => {
    const date = moment(e).format('DD-MM-YYYY');
    this.setState({
      from_date: date
    });
  };

  handleDatesSelected1 = (e) => {
    const date = moment(e).format('DD-MM-YYYY');
    this.setState({
      end_date: date
    });
  };

  render() {
    return (
      <div className="card-header2">
        <div className='d-flex justify-content-between'>
          <h1 className='heading3 mt-20p ml-5p' style={{ width: "240px" }}>Shipments under breach bucket</h1>
          <div className='d-flex'>
            <div className="row">
              <div className="form-group col-xl-4 col-lg-4">
                <label className='dateStyling'> From Date </label>
                <Datetime
                  className='smaller-datetime'
                  key={this.state.from_date}
                  placeholder="Date"
                  value={this.state.from_date}
                  dateFormat="DD-MM-YYYY"
                  timeFormat={false}
                  onChange={(e) => this.handleDatesSelected(e)}
                  required
                />
              </div>
              <div className="form-group col-xl-4 col-lg-4">
                <label className='dateStyling'> To Date </label>
                <Datetime
                  className='smaller-datetime'
                  key={this.state.end_date}
                  placeholder="Date"
                  value={this.state.end_date}
                  dateFormat="DD-MM-YYYY"
                  timeFormat={false}
                  onChange={(e) => this.handleDatesSelected1(e)}
                  required
                />
              </div>
              <div className="form-group col-xl-4 col-lg-4">
                <button className="custom-btn1 f10 label label-success mt-30p" onClick={this.filterDatafordates}>Submit</button>
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex flex-row justify-content-between align-items-center leFadeInLeft w-100 pr-1">
          <div className='col-sm-6'>
            <div id="container-c" style={{ height: '300px', width: '100%', margin: '0 auto' }}></div>
          </div>
        </div>
      </div>
    );
  }
}

// Helper function to format dates
function formatDate(dateString) {
  const parts = dateString.split('-');
  const day = parts[0];
  const month = parts[1];
  const year = parts[2];
  return `${year}-${month}-${day}`;
}

export default ShipmentDashboard;
